var lightboxLinkWrapper = $('.lightbox-link-wrapper'),
    lightbox = $('.lightbox'),
    body = $('body'),
    openLightbox = function openLightbox(lightboxLinkWrapper, modal) {
        lightboxLinkWrapper.find('.lightbox').addClass('show');
        body.css('overflow-y', 'hidden');
        modal.addClass('open');
    },
    closeLightbox = function closeLightbox(lightboxLinkWrapper, modal) {
        lightboxLinkWrapper.find('.lightbox').removeClass('show');
        modal.removeClass('open');
        body.css('overflow-y', '');

    };

if (lightboxLinkWrapper.length) {
    lightboxLinkWrapper.each(function() {

        var _this = $(this),
            link = _this.find('.lightbox-link'),
            modal = _this.find('.adco-lightbox-modal'),
            close = _this.find('.adco-lightbox-close');


        close.on('click', function() {
            closeLightbox(_this, modal);
        });

        modal.on('click', modal, function(e) {
            if (!$.contains(modal[0], e.target)) {
                closeLightbox(_this, modal);
            }
        });

        body.on('keydown', modal, function(e) {
            if (e.which && e.which === 27) {
                closeLightbox(_this, modal);
            }
        });

        link.on('click', function(e) {
            e.preventDefault();
            openLightbox(_this, modal);
        });
    });
}
